import { createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';

import { apiReducerBuilder } from 'utils';
import { RequestStatus } from 'utils/constants';

import { ISavedFilter, Pager, Project } from 'models';

import {
	getPrimaryMarketItems,
	getPrimaryMarketItem,
	investInPrimaryMarketItem,
	getPrimaryMarketItemsMore,
	getPrimaryMarketItemAgreement,
	getFilters,
	createFilter,
	deleteFilter,
} from './actions';

import i18n from 'utils/i18n';

const initialState = {
	status: '',
	items: [] as Project[],
	item: {} as Project,
	pager: { currentPage: 0, pageCount: 1 } as Pager,
	filters: [] as ISavedFilter[],
};

const primaryMarketSlice = createSlice({
	name: 'primaryMarket',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		apiReducerBuilder(builder, getPrimaryMarketItems, (state, action) => {
			const { meta, payload } = action;
			state.status = meta.requestStatus;
			state.items = payload.items;
			state.pager = payload.pager;
		});

		apiReducerBuilder(builder, getPrimaryMarketItemsMore, (state, action) => {
			const { meta, payload } = action;

			state.status = meta.requestStatus;

			state.items = [...state.items, ...payload.items];
			state.pager = payload.pager;
		});

		apiReducerBuilder(builder, getPrimaryMarketItem, (state, action) => {
			const { meta, payload } = action;

			state.status = meta.requestStatus;
			state.item = payload;
		});

		builder.addCase(getFilters.fulfilled, (state, action) => {
			const { payload } = action;
			state.filters = payload;
		});

		builder.addCase(createFilter.fulfilled, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;

			message.success(i18n.t('messageFilterSavedText') as string);
		});

		builder.addCase(createFilter.rejected, (state, action) => {
			state.status = RequestStatus.FULFILLED;
		});

		builder.addCase(deleteFilter.fulfilled, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;

			message.success(i18n.t('messageFilterDeletedText') as string);
		});

		builder.addCase(deleteFilter.rejected, (state, action) => {
			state.status = RequestStatus.FULFILLED;
		});

		builder.addCase(investInPrimaryMarketItem.fulfilled, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
			message.success(i18n.t('youHaveSuccessfullyInvested') as string);
		});

		builder.addCase(investInPrimaryMarketItem.rejected, (state, action) => {
			state.status = RequestStatus.FULFILLED;
		});

		builder.addCase(getPrimaryMarketItemAgreement.fulfilled, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
		});

		builder.addCase(getPrimaryMarketItemAgreement.rejected, (state, action) => {
			state.status = RequestStatus.FULFILLED;
			message.warn(i18n.t('agreementNotFoundText') as string);
		});

		builder.addCase(investInPrimaryMarketItem.pending, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
		});
	},
});

export default primaryMarketSlice.reducer;
